var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view__course_edit_versions"},[_c('course-edit-versions',{ref:"childcomponent"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }